import { useContactContext, useCustomFields } from "@/contexts/contact";
import { getFeaturesEnabled } from "@/utils";
import { useCombinedUserData } from "./useCombinedUserData";
import { isValidPhoneNumber } from "../validation/utils/isValidPhoneNumber";
export function useIsSimplifiedForm() {
    const { phoneNumberRequired, extendedContactForm } = getFeaturesEnabled();
    const combinedUserData = useCombinedUserData();
    const { locationEnabled } = useCustomFields();
    const { isFullNameForm } = useContactContext();
    const requireAddress = locationEnabled && extendedContactForm;
    const checkCompleteInfo = (data) => {
        if (!data)
            return false;
        const hasName = isFullNameForm
            ? !!data.fullName
            : !!data.firstName && !!data.lastName;
        const isPhoneNumberValid = isValidPhoneNumber(data.phoneNumber);
        const hasCompleteContactInfo = !!data.email &&
            hasName &&
            // Phone required → must be valid
            ((phoneNumberRequired && isPhoneNumberValid) ||
                // Phone optional → either empty OR valid
                (!phoneNumberRequired && (!data.phoneNumber || isPhoneNumberValid)));
        const hasCompleteAddress = !!data.street && !!data.city && !!data.zipCode;
        return hasCompleteContactInfo && (!requireAddress || hasCompleteAddress);
    };
    return checkCompleteInfo(combinedUserData);
}
